import React, { useEffect, useState } from 'react'
import { useHistory, useLocation, useParams } from 'react-router-dom'
import { useLoading } from '../../../hooks/loading'
import api from '../../../services/api'
import { FormMenu } from '../components/Form'
import { apiList } from '../domain/api'
import { breadcrumbUpdate } from '../domain/breadcrumb'
import { toolsUpdate } from '../domain/tools'
import { nameActions } from '../domain/info'
import { useToast } from '../../../hooks/toast'
import Container from '../../../components/Container'

const MenuUpdate = (): JSX.Element => {
  const { addToast } = useToast()
  const location = useLocation()
  const history = useHistory()
  const { id } = useParams<{ id: string }>()
  const { activeLoading, disableLoading } = useLoading()
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [menuItem, setMenuItem] = useState<{
    id: string
    name: string
    controller: string
    method: string
    action: string
  }>()

  useEffect(() => {
    async function loadData() {
      activeLoading()
      try {
        const response = await api.get(apiList(id))
        const { data } = response
        setMenuItem(data)
        disableLoading()
      } catch (err) {
        const [, baseUrl, path] = location.pathname.split('/')
        disableLoading()
        addToast({
          type: 'error',
          title: 'Error ao carregar o menu',
          description:
            'Houve um error ao carregar o menu, tente novamente mais tarde!'
        })
        if (path.includes('update')) {
          history.push(`/${baseUrl}`)
        } else {
          history.push(`/${baseUrl}/${path}`)
        }
      }
    }
    loadData()
  }, [activeLoading, addToast, disableLoading, history, id, location.pathname])

  return (
    <Container
      pageTitle={nameActions.update.name}
      breadcrumb={breadcrumbUpdate}
      tools={toolsUpdate}
    >
      <FormMenu
        typeForm="update"
        initialValues={{
          idUpdate: Number(menuItem?.id),
          ...menuItem
        }}
      />
    </Container>
  )
}

export default MenuUpdate
